import { Injectable } from "@angular/core";
var VertexShader = (function () {
    function VertexShader() {
        this.source_ = "\n    attribute vec3 aVertexPosition;\n    attribute vec3 aNormal;\n    //attribute vec2 aTextureCoordinates;\n    \n    uniform mat4 uView;\n    uniform mat4 uProjection;\n    uniform mat4 uTransform;\n    \n    //varying vec2 vTextureCoordinates;\n    varying vec3 vNormal;\n    varying vec3 vVertexPosition;\n\n    void main(void) {       \n        vec4 mv_position = uView * uTransform * vec4(aVertexPosition, 1.0);\n        gl_Position = uProjection * mv_position;\n        //vTextureCoordinates = aTextureCoordinates;\n        vVertexPosition = vec3(mv_position);\n        // Caution this should be changed to a distinct normal_mat = transpose(inverse(M * V)) when scaling is non-uniform\n        vNormal = vec3(uView * uTransform * vec4(aNormal, 0.0));\n    }\n    ";
    }
    ;
    VertexShader.prototype.getShader = function (gl) {
        this.shader_ = gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(this.shader_, this.source_);
        gl.compileShader(this.shader_);
        if (!gl.getShaderParameter(this.shader_, gl.COMPILE_STATUS)) {
            console.log("Vertex shader compilation error: " + gl.getShaderInfoLog(this.shader_));
            return null;
        }
        return this.shader_;
    };
    ;
    VertexShader.decorators = [
        { type: Injectable },
    ];
    VertexShader.ctorParameters = function () { return []; };
    return VertexShader;
}());
export { VertexShader };
//# sourceMappingURL=vertex-shader.js.map